import { render, staticRenderFns } from "./row-buttons.vue?vue&type=template&id=64549b6d&scoped=true&"
import script from "./row-buttons.vue?vue&type=script&lang=js&"
export * from "./row-buttons.vue?vue&type=script&lang=js&"
import style0 from "./row-buttons.vue?vue&type=style&index=0&id=64549b6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64549b6d",
  null
  
)

export default component.exports